import { UserProfile, UserRole } from '@app/types'

export const TAB_CONFIGS = [
  {
    label: 'All Users',
    filterFn: (users: UserProfile[]) => users,
  },
  {
    label: 'Pending Invites',
    filterFn: (users: UserProfile[]) => users.filter((u) => u.status !== 'CONFIRMED'),
  },
]

export const canResendInvite = (status?: string) => {
  return status === 'UNCONFIRMED' || status === 'PENDING' || !status
}

export const USER_STATUS = {
  CONFIRMED: 'CONFIRMED',
  PENDING: 'PENDING',
  UNCONFIRMED: 'UNCONFIRMED',
  UNKNOWN: 'UNKNOWN',
} as const

export type UserStatus = (typeof USER_STATUS)[keyof typeof USER_STATUS]

export const STATUS_ORDER: Record<string, number> = {
  [USER_STATUS.CONFIRMED]: 3,
  [USER_STATUS.PENDING]: 2,
  [USER_STATUS.UNCONFIRMED]: 1,
  [USER_STATUS.UNKNOWN]: 0,
}

export const STATUS_BADGE_CONFIG: Record<
  string,
  { color: 'info' | 'success' | 'warning' | 'error'; label: string }
> = {
  [USER_STATUS.PENDING]: { color: 'info', label: 'pending' },
  [USER_STATUS.CONFIRMED]: { color: 'success', label: 'confirmed' },
  [USER_STATUS.UNCONFIRMED]: { color: 'info', label: 'pending' },
  UNDEFINED: { color: 'info', label: 'pending' },
}

export function handleRolesCascade(userRoles: string[]) {
  let newRoles = userRoles
  const customRoles = userRoles.filter(
    (roles) => ![UserRole.ADMIN, UserRole.MEMBER, UserRole.VIEWER].includes(roles as UserRole),
  )

  if (userRoles.includes(UserRole.ADMIN)) {
    newRoles = [UserRole.ADMIN, UserRole.MEMBER, UserRole.VIEWER, ...customRoles]
  } else if (userRoles.includes(UserRole.MEMBER)) {
    newRoles = [UserRole.MEMBER, UserRole.VIEWER, ...customRoles]
  } else if (userRoles.length === 0 || !userRoles.includes(UserRole.VIEWER)) {
    newRoles = [UserRole.VIEWER, ...customRoles]
  }
  return newRoles
}

export const LAYER_TYPE_COLORS: Record<string, 'secondary' | 'info' | 'success'> = {
  asset: 'secondary',
  hazard: 'success',
  information: 'info',
}
